import Collapse from '_technical/components/Collapse/Collapse';
import ButtonUpload from '_technical/components/Collapse/ButtonUpload';
import CollapseContent from '_technical/components/Collapse/CollapseContent';
import FileLine from '_technical/components/Collapse/FileLine';

export { ButtonUpload, CollapseContent, FileLine };
export default Collapse;
